import script from "./WidgetBreadcrumbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./WidgetBreadcrumbs.vue?vue&type=script&lang=ts&setup=true"

import "./WidgetBreadcrumbs.vue?vue&type=style&index=0&id=1821d6ec&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4139241753/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1821d6ec"]])

export default __exports__